var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('entity-feature-card');
import { theme, breakpoints } from '@shapeable/theme';
import { EntityLink } from './entity-link';
import { EntityThumbnailImage } from './entity-image';
import { Icon } from '../elements/icon';
import { Icons } from '../icons';
import { MarkdownContent } from '../elements/markdown-content';
import { coalesce } from '../../utils/coalesce';
import { useLink } from '../../hooks/use-link';
export var EntityFeatureCardDefaultProps = {
  showSubtitle: true,
  showDescription: true,
  showFamily: false
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LinkStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    display: block;\n\n    &:hover {\n      filter: brightness(1.1);\n    }\n  "], ["\n    position: relative;\n    display: block;\n\n    &:hover {\n      filter: brightness(1.1);\n    }\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    box-sizing: border-box;\n    padding: ", " ", ";\n    background: rgba(0,0,0,0.6);\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n  "], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    box-sizing: border-box;\n    padding: ", " ", ";\n    background: rgba(0,0,0,0.6);\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n  "])), theme.UNIT(4), theme.UNIT(3))
});
var FamilyStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: stretch;\n\n  "], ["\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: stretch;\n\n  "])))
});
var TitlesStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var NameStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-family: ", ";\n    color: ", ";\n    padding-right: ", ";\n    font-size: 1.6em;\n    font-weight: 500; \n    line-height: 1.1em;\n  "], ["\n    font-family: ", ";\n    color: ", ";\n    padding-right: ", ";\n    font-size: 1.6em;\n    font-weight: 500; \n    line-height: 1.1em;\n  "])), theme.FONT('serif'), theme.COLOR('light'), theme.UNIT(10))
});
var SubtitleStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-family: ", ";\n    color: ", ";\n    padding-right: ", ";\n    font-weight: 300;\n    font-size: 1em;\n    margin-top: 6px;\n    line-height: 1.1em;\n\n    b, strong {\n      font-weight: 600;\n      color: ", ";\n    }\n  "], ["\n    font-family: ", ";\n    color: ", ";\n    padding-right: ", ";\n    font-weight: 300;\n    font-size: 1em;\n    margin-top: 6px;\n    line-height: 1.1em;\n\n    b, strong {\n      font-weight: 600;\n      color: ", ";\n    }\n  "])), theme.FONT('serif'), theme.COLOR('light'), theme.UNIT(4), theme.COLOR('light'))
});
var IconStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-top: ", ";\n    ", ";\n  "], ["\n    margin-top: ", ";\n    ", ";\n  "])), theme.UNIT(0), theme.FILL('light'))
});
var ImageStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var DescriptionStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    line-height: 1.6em;\n    padding: ", ";\n  "], ["\n    line-height: 1.6em;\n    padding: ", ";\n  "])), theme.UNIT(3)),
  tablet: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    padding: ", " 0;\n  "], ["\n    padding: ", " 0;\n  "])), theme.UNIT(3))
});
var FamilyItemStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n    flex-grow: 1;\n    justify-content: space-between;\n    flex-direction: row;\n    color: ", ";\n    padding: ", " ", ";\n    border-top: 1px solid ", ";\n    background: rgba(0,0,0,0.6);\n\n    &:hover {\n      background: rgba(0,0,0,0.7);\n    }\n  "], ["\n    display: flex;\n    flex-grow: 1;\n    justify-content: space-between;\n    flex-direction: row;\n    color: ", ";\n    padding: ", " ", ";\n    border-top: 1px solid ", ";\n    background: rgba(0,0,0,0.6);\n\n    &:hover {\n      background: rgba(0,0,0,0.7);\n    }\n  "])), theme.COLOR('light'), theme.UNIT(4), theme.UNIT(3), theme.COLOR('light'))
});
var FamilyItemNameStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Link: styled(EntityLink)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Titles: styled.div.attrs(cls.attr('titles'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), TitlesStyles),
  Name: styled.span.attrs(cls.attr('name'))(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Subtitle: styled(MarkdownContent).attrs(cls.attr('subtitle'))(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles),
  Icon: styled(Icon)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Family: styled.div.attrs(cls.attr('family'))(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), FamilyStyles),
  FamilyItem: styled.span.attrs(cls.attr('family-item'))(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), FamilyItemStyles),
  FamilyItemName: styled.span.attrs(cls.attr('family-item-name'))(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), FamilyItemNameStyles),
  Image: styled(EntityThumbnailImage)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Description: styled(MarkdownContent)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
export var EntityFeatureCard = function EntityFeatureCard(props) {
  var className = props.className,
      entity = props.entity,
      showSubtitle = props.showSubtitle,
      showDescription = props.showDescription,
      showFamily = props.showFamily;
  var description = props.description || coalesce(entity, ['description.text', 'summary.text', 'intro.text', 'content.text', 'openGraph.description']);
  var title = entity.title,
      name = entity.name,
      subtitle = entity.subtitle,
      _a = entity.family,
      family = _a === void 0 ? [] : _a;
  var hasDescription = showDescription && !!description;
  var navigate = useLink().navigate;
  var hasFamily = showFamily && family.length > 1;
  var hasSubtitle = !!entity.subtitle && showSubtitle;
  var aspectRatio = props.aspectRatio || {
    base: 4 / 3,
    desktopMid: 1210 / 1014
  };

  var familyItemOnClick = function familyItemOnClick(item) {
    return function (event) {
      if (item.path) {
        event.stopPropagation();
        event.preventDefault();
        navigate(item.path);
      }
    };
  };

  return React.createElement(My.Container, {
    className: className
  }, React.createElement(My.Link, {
    entity: entity
  }, React.createElement(My.Image, {
    entity: entity,
    aspectRatio: aspectRatio
  }), React.createElement(My.Body, null, React.createElement(My.Titles, null, React.createElement(My.Name, null, title || name), hasSubtitle && !hasFamily && React.createElement(My.Subtitle, {
    text: subtitle
  })), React.createElement(My.Icon, {
    size: 16
  }, React.createElement(Icons.ChevronRight, null))), hasFamily && React.createElement(My.Family, null, family.map(function (familyItem) {
    return React.createElement(My.FamilyItem, {
      onClick: familyItemOnClick(familyItem),
      className: cls.sub('family-item')
    }, familyItem.subtitle, React.createElement(My.Icon, {
      size: 16
    }, React.createElement(Icons.ChevronRight, null)));
  }))), hasDescription && React.createElement(My.Description, {
    text: description
  }));
};
EntityFeatureCard.cls = cls;
EntityFeatureCard.defaultProps = EntityFeatureCardDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25;